<template>
  <div class="fluid reset2-container" >
    <v-layout justify-content-center row wrap class="reset2-wrapper">
      <v-flex xs12 md12 class="reset2-right" >
        <div class="content-frame">
              <img class="mb-3" src="../../assets/img/assuraf_lg.png"  width="120" alt="assuraf_playstor">
        <div v-if="!resetSuccess">
        <div class="title-row">
          <div class="icon-badge"><i class="fa fa-key"></i></div>
          <h2 class="form-title">{{ $t('reset_password.title') }}</h2>
        </div>
        <p class="form-subtitle small">{{ $t('reset_password.critere_label') }}</p>

        <div class="password-strength">
          <div class="strength-bar">
            <div class="strength-fill" :class="'lvl-' + strength"></div>
          </div>
          <div class="critere">
            <div :class="['badge', critere.length ? 'ok' : '']"><i :class="['badge-icon', critere.length ? 'ok' : '']">✓</i><span>15+</span> {{ $t('reset_password.caractere_label') }}</div>
            <div :class="['badge', critere.upper ? 'ok' : '']"><i :class="['badge-icon', critere.upper ? 'ok' : '']">✓</i><span>AA</span> {{ $t('reset_password.majuscule_label') }}</div>
            <div :class="['badge', critere.lower ? 'ok' : '']"><i :class="['badge-icon', critere.lower ? 'ok' : '']">✓</i><span>aa</span> {{ $t('reset_password.miniscule_label') }}</div>
            <div :class="['badge', critere.number ? 'ok' : '']"><i :class="['badge-icon', critere.number ? 'ok' : '']">✓</i><span>123</span> {{ $t('reset_password.nombre_label') }}</div>
            <div :class="['badge', critere.symbol ? 'ok' : '']"><i :class="['badge-icon', critere.symbol ? 'ok' : '']">✓</i><span>@$#</span> {{ $t('reset_password.symbole_label') }}</div>
          </div>
        </div>

        <div class="field">
          <label class="label">{{ $t('reset_password.password_label') }}</label>
          <div class="input-box">
            <input :type="showPassword ? 'text' : 'password'" :placeholder="$t('reset_password.password_placeholder')" v-model="password_new" class="box-input" />
            <span class="box-eye" @click="togglePasswordVisibility">
              <i v-if="showPassword" class="fa fa-eye-slash"></i>
              <i v-else class="fa fa-eye"></i>
            </span>
          </div>
        </div>

        <div class="field mt-3">
          <label class="label">{{ $t('reset_password.confirm_password_label') }}</label>
          <div class="input-box">
            <input :type="showConfirmation ? 'text' : 'password'" :placeholder="$t('reset_password.confirm_password_placeholder')" v-model="confirmation" class="box-input" />
            <span class="box-eye" @click="toggleConfirmationVisibility">
              <i v-if="showConfirmation" class="fa fa-eye-slash"></i>
              <i v-else class="fa fa-eye"></i>
            </span>
          </div>
        </div>



        <div class="actions">
          <button class="btn-primary" type="button" :disabled="!critereValid" @click="setChangedPassword">{{ $t('reset_password.reinitialiser_button_label') }}</button>
          <a class="link-blue" href="javascript:void(0)" @click="$router.push('/')">{{ $t('reset_password.retour_login_button_label') }}</a>
        </div>
        </div>
        <div v-else class="success-card">
           <div class="title-row">
          <div class="icon-badge"><i class="fa fa-check"></i></div>
          <h2 class="form-title">{{ $t('reset_password.success_message_title') }}</h2>
        </div>
          <p class="success-subtitle">{{ $t('reset_password.success_message_content') }}</p>
          <button class="btn-blue" type="button" @click="$router.push('/')">{{ $t('reset_password.connexion_label') }}</button>
        </div>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Api from '../../services/Api'
export default {
  name: 'ResetPassword',
  data() {
    return {
      emailDisplay: null,
      tokenUserData: null,
      showPassword: false,
      showConfirmation: false,
      password_new: null,
      confirmation: null,
      ToastTabSucess: {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 5000,
        fitToScreen: true,
        type: 'success',
        className: 'custom-success-class'
      },
      ToastTabError: {
        theme: 'toasted-primary',
        position: 'top-center',
        duration: 5000,
        fitToScreen: true,
        type: 'error'
      },
      isValidToken: false,
      resetSuccess: false,
      containerHeight: window.innerHeight
    }
  },
  computed: {
    critere() {
      const p = this.password_new || ''
      return {
        length: p.length >= 15,
        upper: /[A-Z]/.test(p),
        lower: /[a-z]/.test(p),
        number: /\d/.test(p),
        symbol: /[\W_]/.test(p)
      }
    },
    critereValid() {
      const confirm = this.confirmation || ''
      const pw = this.password_new || ''
      const match = confirm.length > 0 && confirm === pw
      return this.critere.length && this.critere.upper && this.critere.lower && this.critere.number && this.critere.symbol && match
    },
    strength() {
      const c = this.critere
      let count = 0
      if (c.length) count++
      if (c.upper) count++
      if (c.lower) count++
      if (c.number) count++
      if (c.symbol) count++
      return count
    }
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword
    },
    toggleConfirmationVisibility() {
      this.showConfirmation = !this.showConfirmation
    },
    computeContainerHeight() {
      const app = document.querySelector('.v-app')
      if (app && app.children && app.children.length >= 3) {
        const header = app.children[0]
        const footer = app.children[2]
        const headerH = header ? header.offsetHeight : 0
        const footerH = footer ? footer.offsetHeight : 0
        this.containerHeight = Math.max(0, window.innerHeight - headerH - footerH)
      } else {
        this.containerHeight = window.innerHeight
      }
    },
    checklink_to_set_user_password(token) {

      // if (!token) {
      //   this.isValidToken = false
      //   return
      // }

      // this.$toasted.show('Lien invalide ou expiré!!.', this.ToastTabError)
      // setTimeout(() => (this.$router.push('/')), 3000);

      //const payload = { token }
      // Api().post('user/checklink/set-password', payload)
      //   .then(r => {
      //     if (r && r.data && r.data.ok === 0) {
      //       this.$toasted.show('Lien invalide ou expiré!!.', this.ToastTabError)
      //       setTimeout(() => (this.$router.push('/')), 3000);
      //       this.isValidToken = false
      //     } else {
      //       this.isValidToken = true
      //     }
      //   })
      //   .catch(err => {
      //     if (err.response && err.response.data && err.response.data.msg) {
      //       this.$toasted.show(err.response.data.msg, this.ToastTabError)
      //     } else {
      //       this.$toasted.show('Erreur lors de la vérification du lien', this.ToastTabError)
      //     }
      //     this.isValidToken = false
      //   })
    },
    isPasswordStrong(password) {
      const strongPasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[\\W_]).{8,}$/
      return strongPasswordRegex.test(password)
    },
    async setChangedPassword() {
      if (!this.tokenUserData) {
        this.$toasted.show('Lien de réinitialisation manquant ou invalide', this.ToastTabError)
        return
      }
      if (this.password_new && this.confirmation) {
        if (this.confirmation === this.password_new) {
            const data = {
              token: this.tokenUserData,
              password: this.password_new,
            }
            await Api().post('user/password', data)
              .then((response) => {
                if(response.data.code=="ok"){
                this.$toasted.show('Mot de passe modifié avec succès', this.ToastTabSucess)
                this.resetSuccess = true
                }
              })
              .catch(error => {
                  const data = (error.response && error.response.data) || {}
                  // Mot de passe refuse par la politique (longueur, historique...) :
                  // on affiche la raison et on reste sur la page, le lien reste valable.
                  if (Array.isArray(data.errors) && data.errors.length) {
                    this.$toasted.show(data.msg || data.message, this.ToastTabError)
                    return
                  }
                  this.$toasted.show(data.msg || data.message || 'Une erreur est survenue, lien invalide ou expiré !', this.ToastTabError)
                  setTimeout(() => (this.$router.push('/')), 3000);
              })
        } else {
          this.$toasted.show('Les deux mots de passe doivent être identiques', this.ToastTabError)
        }
      } else {
        this.$toasted.show('Veuillez saisir et confirmer le mot de passe', this.ToastTabError)
      }
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    this.computeContainerHeight()
    window.addEventListener('resize', this.computeContainerHeight)
    const rawToken = decodeURIComponent(this.$route.params.token)
    if (rawToken) {
      const normalized = rawToken.replace(/[_]/g, '/')
      this.tokenUserData = normalized
      //this.checklink_to_set_user_password(this.tokenUserData)
    }
  }
}
</script>

<style lang="less" scoped>
::placeholder {
  font-size: 13px;
}

.reset2-container {
  background: #fafafa;
  display: flex;
  align-items: center;
  justify-content: center;
}
.reset2-wrapper {
  width: 100%;
  //padding: 100px 3% 60px 3%;
  height: 100vh;
  // max-width: 1100px;
  //padding: 16px;
}
.reset2-left {
  background: #FFFBF6;
  color: #ffffff;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
}
.quote {
  max-width: 420px;
  padding: 50px;
}
.quote-mark {
  font-size: 32px;
  line-height: 1;
  margin-bottom: 16px;
}
.quote-text {
  opacity: 0.9;
  font-size: 16px;
  line-height: 1.7;
  color: #1f2937;
}
.quote-author {
  margin-top: 18px;
  font-weight: 700;
  color: #1f2937;
}
.reset2-right {
  //box-shadow: 0 0px 80px rgba(0, 0, 0, 0.1);
  background-color: #fafafa;
  // border-radius: 10px;
  padding: 24px 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
 .content-frame {
  width: 100%;
  max-width: 640px;
  padding: 12px 0;
}
.title-row {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 8px;
}
.title-row .icon-badge {
  margin-bottom: 0;
}
.title-row .form-title {
  margin: 0;
}
.brand {
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 8px;
}
.brand-accent {
  color: #ffa409;
}
.form-title {
  font-size: 24px;
  font-weight: 700;
  margin: 8px 0 4px;
}
.form-subtitle {
  color: #62708a;
  margin: 0 0 8px;
}
.form-subtitle.small {
  margin-top: 6px;
}
.password-strength {
  width: 100%;
}
.strength-bar {
  height: 4px;
  border-radius: 4px;
  background: #e3e8f3;
  margin-bottom: 12px;
  overflow: hidden;
}
.strength-fill {
  height: 100%;
  width: 0;
  border-radius: 4px;
  background: #e11d48;
  transition: width .3s ease, background-color .3s ease;
}
.strength-fill.lvl-1 {
  width: 20%;
  background: #e11d48;
}
.strength-fill.lvl-2 {
  width: 40%;
  background: #f97316;
}
.strength-fill.lvl-3 {
  width: 60%;
  background: #eab308;
}
.strength-fill.lvl-4 {
  width: 80%;
  background: #84cc16;
}
.strength-fill.lvl-5 {
  width: 100%;
  background: #437c41;
}
.critere {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0 0 18px;
}
.badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #e3e8f3;
  border-radius: 10px;
  padding: 6px 10px;
  color: #3f4a5e;
  background: #ffffff;
  font-size: 13px;
  transition: background-color .25s ease, border-color .25s ease, color .25s ease;
}
.badge-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  font-size: 10px;
  font-style: normal;
  font-weight: bold;
  color: #9aa3b2;
  background: #eef1f7;
  transition: background-color .25s ease, color .25s ease;
}
.badge-icon.ok {
  color: #fff;
  background: #437c41;
}
.badge.ok {
  border-color: #bfe3bd;
  color: #2f6b2d;
}
.label {
  display: block;
  font-size: 15px;
  margin-bottom: 6px;
  color: #2d3748;
  font-weight: 500;
}
.input-box {
  position: relative;
}
.box-input {
  width: 100%;
  height: 44px;
  border: 1px solid #d7deeb;
  border-radius: 8px;
  padding: 0 44px 0 12px;
  color: #1f2937;
  background: #f9fbff;
}
.box-input:focus {
  outline: none;
  border-color: #ffa409;
  background: #ffffff;
}
.box-eye {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #62708a;
  cursor: pointer;
}
.actions {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-top: 16px;
}
.btn-primary {
  height: 44px;
  padding: 0 22px;
  border-radius: 8px;
  background: #ffa409;
  color: #fff;
  border: none;
  cursor: pointer;
  font-weight: 400;
}
.btn-primary:disabled {
  background: #ffa409;
  cursor: not-allowed;
  //opacity: 0.7;
}
.btn-primary:hover {
  filter: brightness(1.05);
}
.link-blue {
  color: #ffa409;
  text-decoration: none;
  font-weight: 600;
}
.success-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  padding: 24px;
}
.success-brand {
  font-weight: 700;
  color: #2563eb;
}
.success-title {
  font-size: 22px;
  font-weight: 700;
  color: #1f2937;
}
.success-subtitle {
  color: #62708a;
  max-width: 540px;
}
.btn-blue {
  height: 44px;
  padding: 0 24px;
  border-radius: 8px;
  background: #ffa409;
  color: #fff;
  border: none;
  font-weight: 400;
  cursor: pointer;
}
.btn-blue:hover {
  filter: brightness(1.05);
}
.icon-badge {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #ffa409, #ffa400);
  box-shadow: 0 12px 28px rgba(234, 177, 54, 0.35);
  color: #000;
  margin-bottom: 16px;
}
.icon-badge i {
  font-size: 18px;
}
@media (max-width: 960px) {
  .reset2-left {
    min-height: 280px;
  }
}
@media (max-width: 600px) {
  .reset2-right {
    padding: 16px;
  }
}
</style>
